<template>
  <transition name="router-anim">
    <div class="registration">

      <div class="card " id="">
        <header class="card-header ">
          <img class="" :src="$t('logoUrl')" alt="logo" style="height:35px; margin: 5px auto;">
        </header>


        <div class="card-content">
          <div class="has-text-centered">
            <h3 class="title is-3">{{ $t('SignupUrlSelect.heading') }}</h3>
            <h3 class="subtitle" style="font-size:14px;">{{ $t('SignupUrlSelect.subtitle') }}</h3>
          </div>


          <div class="url-input">
            <div class="columns is-gapless is-mobile is-vcentered">
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input" type="text" placeholder="yourname" style="text-align:right;padding-right: 4px;"
                      v-model="chosenUrl" required
                      :class="{'is-loading':isChecking, 'free': checkingResponse == 'Free', 'not-free': (checkingResponse !== 'Проверить'&&checkingResponse !== 'Free'&&!isChecking) }">
                  </div>
                </div>
              </div>

              <div class="column" style="max-width: 120px;">
                <p style="margin-left: 3px;">.{{ $t('domain') }}</p>
              </div>
              <div class="column" style="max-width: 50px;">
                <button class="button is-small" @click="checkUrl"
                  style="margin-left:2rem; min-width: 38px; border-radius:6px;" :class="{'is-loading':isChecking}">
                  <svg v-if="!isChecking" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                    fill="none" stroke="gray" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-rotate-cw">
                    <polyline points="23 4 23 10 17 10"></polyline>
                    <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <div class="notification is-light">
            {{ $t('SignupUrlSelect.note') }}
          </div>


        </div>

        <footer class="has-text-centered">
          <button class="button is-success" :class="{'is-loading':isLoading || isChecking}" :disabled="isLoading || isChecking" style="margin: 1rem;color:white!important;"
            @click="next()">{{ $t('SignupPlaceInfo.continue') }}</button>
          <div id="status-message">
            <p>{{statusMessage}}</p>
          </div>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "underscore";
import api from '../api'
import is from "is_js"

export default {
  components: {},

    computed: _.extend(
    {},
    mapGetters({
      info: "getPlaceInfo"
    }),
    {}
  ),

  data() {
    return {
      isLoading: false,
      isChecking: false,
      chosenUrl: "",
      checkingResponse: "Проверить",
      statusMessage: ""
    };
  },
  methods: _.extend({}, mapActions(["populatePlaceInfo", "updatePlaceInfo"]), {
    checkUrl: function() {
      
      this.chosenUrl = this.chosenUrl.toLowerCase()
      this.isChecking = !this.isChecking;
      api.checkUrl(this.chosenUrl)
          .then(response => {
            this.isChecking = !this.isChecking;
            this.checkingResponse = response.data;
            this.$ma.trackEvent({category: 'event', action: 'URL checked', properties:{taskSource: "Refresh button", url: this.chosenUrl, response: response.data}})
            this.checkingFeedback(response)
            
            // console.log(response.data)
          }
        )
      
    },
    next: function() {
      this.chosenUrl = this.chosenUrl.toLowerCase()
      this.isChecking = !this.isChecking;
      let _this = this
      api.checkUrl(this.chosenUrl)
          .then(response => {
            _this.isChecking = !_this.isChecking;
            _this.checkingResponse = response.data;
            console.log(response.data)
            _this.$ma.trackEvent({category: 'event', action: 'URL checked', properties:{taskSource: "Next button", url: _this.chosenUrl, response: response.data}})
            this.checkingFeedback(response)

            if (response.data == "Free") {
              _this.statusMessage =  this.$t('SignupUrlSelect.creating')
              _this.isLoading = !_this.isLoading;
              
              _this.info.url = _this.chosenUrl
              api.zapierPersist(_this.$i18n.locale, _this.info);
              api.sendNotification({message: "Signup completed: " + _this.info.email + 
                            "\nName: " + _this.info.placeName  + 
                            "\nPhone: " + _this.info.phone + 
                            // "\nTemplate: " + _this.templateSelect + 
                            "\nurl: " + _this.chosenUrl + "." + _this.info.domain + 
                            // "\n"+JSON.stringify(_this.features) +
                            "\nTheme: "+ _this.$t('Themes.' + _this.info.background)
                          })
              api.changeUrl(_this.chosenUrl, _this.info.identityId)
                  .then(response => {
                    if (response.data == "Successfully done") {
                      _this.statusMessage =  this.$t('SignupUrlSelect.saving')
                      
                      _this.info.signupStep = "dashboard"
                      _this.$ma.setUserProperties({url: _this.chosenUrl})
                      _this.updatePlaceInfo(_this.info)
                        .then(() => {
                          _this.$ma.trackEvent({category: 'event', action: 'URL set', properties:{url: _this.chosenUrl, lang: _this.$i18n.locale}})
                          if (_this.$metrika) {
                            _this.$metrika.reachGoal(137533423)
                            _this.$metrika.reachGoal("signup_completed")
                          }
                          this.$gtm.trackEvent({
                            event: "signup",
                            category: "signup",
                            action: "signup",
                            label: "y9KyCJatuuIBENKR84MC",
                            placeUrl: _this.chosenUrl
                          });
                          _this.isLoading = !_this.isLoading;
                          _this.statusMessage =  this.$t('SignupUrlSelect.done')
                          console.log(response.data)
                          api.publishApp(_this.info.identityId)
                          api.refreshQR(_this.info.domain,_this.info.url);
                          
                          
                          // move to next step
                          let nextStep = "/dashboard?dialog=checklist"
                          // let nextStep = "/signup_" + (parseInt(_this.$route.path.split("_").pop())+1).toString()
                          // window.onbeforeunload = function () {}
                          _this.$router.replace(_this.$route.query.redirect || nextStep);
                          // if (is.mobile())
                          //   //TODO
                          //     window.open(nextStep, "_self");
                          //   else 
                          //     _this.$router.replace(_this.$route.query.redirect || nextStep);
                        })
                    }
                  })
            }
            else {
              console.log('URL not available')
            }
          }
        )
     
      
    },
    checkingFeedback(response) {
      if (response.data == "Taken")
        this.$buefy.toast.open(this.chosenUrl + "." + this.info.domain + " " + this.$t("SignupUrlSelect.taken"))
      if (response.data == "Reserved")
        this.$buefy.toast.open(this.$t("SignupUrlSelect.reserved"))
      if (response.data == "Free")
        this.$buefy.toast.open(this.chosenUrl + "." + this.info.domain + " " + this.$t("SignupUrlSelect.free"))
    }
  }),
  mounted() {
    // window.onbeforeunload = function() {
    //   return "Are you sure you want to exit?";
    // };
    history.pushState(null, null, null);
    this.$title = this.$t('title') + " | " + this.$t('Signup.title')
    this.$ma.trackEvent({category: 'event', action: 'Page viewed: ' + this.$route.fullPath, label : null, value : null})

  }
}
</script>

<style scoped>
html {
    overflow: hidden;
}
body {
  background: #fff !important;
}


.free {
  color: green !important;
  border-color: green !important;
}

.not-free {
  color: red !important;
  border-color: red !important;
}

button:focus,
button:active {
  border-color: #dbdbdb !important;
  box-shadow: none !important;
}


.url-input {
  margin: 3rem auto;
  max-width: 70%;
}

.card {
  min-height: 70vh;
  height: 100vh;
}

footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #8080805c;
}

#status-message {
  position: absolute;
  top: -30px;
  left: 0;
  right: 0;
}

@media screen and (min-width:768px) {
 .card-content {
    margin-top: 5vh;
  }
}

@media screen and (max-width:768px) {
  /* #signup1 .box {
    padding: 1rem 0rem 2rem;
    box-shadow: none;
  } */

  /* #signup1 .form {
    width: 80%;
    margin: 1.5rem auto 0px;

  } */

  /* .registration .field:not(:last-child) {
    margin-bottom: 0.75rem;
  } */

  /* #signup1 .notification {
    margin-left: 1rem;
    margin-right: 1rem;
    margin-bottom: 0;
    padding: 0.5rem 2.5rem 0.5rem 1.5rem;
  } */

  .label:not(:last-child) {
    margin-bottom: 0;
  }

  .url-input {
    max-width: 95% !important;
  }

  .card {
    min-height: 100vh;
  }
    
}
@supports (-webkit-appearance:none) {
    .card {
      min-height: calc(100vh - 56px);
    }
}
</style>

